import { Button } from '@/shared/ui';
import styles from './Hero.module.css';

export function Hero() {
  return (
    <section className={styles.hero}>
      <h1>Modules, experiments, and patterns.</h1>
      <p className={styles.sub}>
        Explore small, focused surfaces. Some are experiments. Some become products. All are built
        in the open.
      </p>
      <div className={styles.cta}>
        <Button as="a" href="#gallery">
          Browse modules
        </Button>
        <Button as="a" href="#about" variant="secondary">
          What is this?
        </Button>
      </div>
    </section>
  );
}
